import React, { Component, useEffect, useState } from 'react'
// import { Doughnut } from 'react-chartjs-2';
import CountUp from 'react-countup'
import axios from 'axios'
import Atropos from 'atropos/react'
import './Dashboard.css'
import { Link, useHistory } from 'react-router-dom'
import Conflictgame from './Conflictgame'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut, Bar } from 'react-chartjs-2'
import { Line } from 'react-chartjs-2'
import { yellow } from '@mui/material/colors'
import Loader from 'react-js-loader'
import loader from '../icons/loader1.gif'
import { apiRequest } from '../store/allApi';

const $ = require('jquery')
$.Datatable = require('datatables.net')

const ClintPage = () => {
  const [loading, setLoading] = useState(false)
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  const history = useHistory()
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [Admin, setAdmin] = useState(0)
  const [allData, setAllData] = useState([])
  const [todayAllData, setTodayAllData] = useState([])
  const [olddayaData, set30DayaAllData] = useState([])
  const [today, setToday] = useState(false)
  const [User, setUser] = useState(0)

  const [challange, setChallange] = useState(0)

  const [todayData, setTodayData] = useState()

  var date = new Date();
  // Outputs the current date and time
  const getYear = date.getFullYear(); // Outputs the current year
  const getgetMonth = date.getMonth(); // Outputs the current year
  const getDate = date.getDate(); // Outputs the current year

  const dateget = `${getYear}-${getgetMonth + 1}-${getDate}`;

  const [DOB, setDob] = useState("");

  const getPreviousDay = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() - 1);
    return date.toISOString().split('T')[0];
  };

  const TodayAll = async () => {

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    let lastdayDateParam;
    let startDateParam;

    if (!DOB) {
      // If DOB is not set, use current date and previous date
      const currentDate = new Date();
      startDateParam = currentDate.toISOString().split('T')[0];
      const previousDate = new Date(currentDate);
      previousDate.setDate(previousDate.getDate() - 1);
      lastdayDateParam = previousDate.toISOString().split('T')[0];
    } else {
      // If DOB is set, use previous day as globledate and DOB as startDate
      lastdayDateParam = getPreviousDay(DOB);
      startDateParam = DOB;
    }

    try {
      const urlDate = `api/calculation/walletbalance?lastdayDate=${lastdayDateParam}&startDate=${startDateParam}`;
      const res = await apiRequest(urlDate, "GET", null, headers);
      setAllData(res.data);
    } catch (error) {
      //  console.log(e);
    } finally {
      // setLoading(false)
    }
  }











  function normalizeDates(startDate, endDate) {
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const end = new Date(startDate);
    end.setHours(23, 59, 59, 999);

    return [start, end];
  }

  function filterData() {
    const previous = getPreviousDay(DOB);
    const [s, e] = normalizeDates(previous, DOB);
  }

  function daterange(s, e) {
    if (s > e) {
      alert('Starting date is greater than ending date')
    } else {
      setStartDate(s)
      setEndDate(e)
    }
    console.log(s, e)
    // Change start date format
    var startDate = new Date(s)
    var startDay = startDate.getDate()
    var startMonth = startDate.getMonth() + 1 // Months are zero-based
    var startYear = startDate.getFullYear()
    var startHours = startDate.getHours()
    var startMinutes = startDate.getMinutes()
    var startSeconds = startDate.getSeconds()

    // Change end date format
    var endDate = new Date(e)
    var endDay = endDate.getDate()
    var endMonth = endDate.getMonth() + 1 // Months are zero-based
    var endYear = endDate.getFullYear()
    var endHours = endDate.getHours()
    var endMinutes = endDate.getMinutes()
    var endSeconds = endDate.getSeconds()
  }

  // ...

  useEffect(() => {
    TodayAll()

    // Some1()
  }, [])

  useEffect(() => {
    TodayAll()
    if (DOB) {
      filterData()
    }
  }, [DOB])


  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
   <div className="container mt-4">
  <div className="card shadow">
    <div className="card-header text-center">
      <h3>Hisab Khitab Summary</h3>
        <div className='mb-3'>
          <input
            type="date"
            name="DOB"
            placeholder="Date of Birth"
            value={DOB}
            onChange={e => setDob(e.target.value)}
            required
          />
        </div>
      <p className="mb-0">{DOB}</p>
    </div>

    <div className="card-body">
      <table className="table table-bordered">
        <tbody>
          <tr>
            <td><strong>Total Open Balance</strong></td>
            <td className="text-end">
              ₹ {allData?.finalData?.todayOpenWalletBalance || 0}
            </td>
          </tr>

          <tr>
            <td>Total Deposit</td>
            <td className="text-end">
              + ₹ {allData?.finalData?.todayDeposit || 0}
            </td>
          </tr>

          <tr>
            <td>Total Bonus</td>
            <td className="text-end">
              + ₹ {allData?.finalData?.todaybonus || 0}
            </td>
          </tr>

          <tr className="table-secondary">
            <td colSpan="2"></td>
          </tr>

          <tr>
            <td>Total Withdraw</td>
            <td className="text-end">
              - ₹ {allData?.finalData?.todayWithdraw || 0}
            </td>
          </tr>

          <tr>
            <td>Total Penalty</td>
            <td className="text-end">
              - ₹  {allData?.finalData?.todayPenelty || 0}
            </td>
          </tr>

          <tr className="table-secondary">
            <td colSpan="2"></td>
          </tr>

          <tr>
            <td>Total Commission</td>
            <td className="text-end">
              - ₹ {allData?.todayGlobalData?.admin_commision || 0}
            </td>
          </tr>

          <tr>
            <td>Referral Commission</td>
            <td className="text-end">
              - ₹ {allData?.todayGlobalData?.refer_commision || 0}
            </td>
          </tr>

          <tr>
            <td>Referral Redeem</td>
            <td className="text-end">
              + ₹ {allData?.todayGlobalData?.referralreedem || 0}
            </td>
          </tr>
            <tr className="table-success">
            <td>
              <strong>Total</strong>
            </td>
            <td className="text-end">
              <strong>
                ₹ {allData?.finalData?.todayOpenWalletBalance+allData?.finalData?.todayDeposit+allData?.finalData?.todaybonus-allData?.finalData?.todayWithdraw-allData?.finalData?.todayPenelty - allData?.todayGlobalData?.admin_commision - allData?.todayGlobalData?.refer_commision +allData?.todayGlobalData?.referralreedem|| 0}
              </strong>
            </td>
          </tr>

          <tr className="table-secondary">
            <td colSpan="2"></td>
          </tr>

        
          <tr className="table-success">
            <td>
              <strong>Close Balance</strong>
            </td>
            <td className="text-end">
              <strong>
                ₹ {allData?.finalData?.todayClosedWalletBalance || 0}
              </strong>
            </td>
          </tr>

          <tr className="table-danger">
            <td>
              <strong>Difference</strong>
            </td>
            <td className="text-end">
              <strong>
                ₹ {(allData?.finalData?.todayOpenWalletBalance+allData?.finalData?.todayDeposit+allData?.finalData?.todaybonus-allData?.finalData?.todayWithdraw-allData?.finalData?.todayPenelty - allData?.todayGlobalData?.admin_commision - allData?.todayGlobalData?.refer_commision +allData?.todayGlobalData?.referralreedem) - allData?.finalData?.todayClosedWalletBalance|| 0}
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
  )
}

export default ClintPage
